import { validWebshopPrice, validWebshopVat } from "./offerInput";
export interface ShopOfferSettings {
  packageDocId: string;
  priceWebshop: number | null;
  vatRate: number | null;
  shopEnabled: boolean;
  revision: number;
}
export type ShopOfferBody = Omit<ShopOfferSettings, "packageDocId" | "revision"> & { expectedRevision: number; reason?: string };
export type ShopOfferIntent = { uid: string; id: string; body: ShopOfferBody; key: string; inFlight: boolean; uncertain?: boolean };
export const shopOfferId = (value: unknown): value is string => typeof value === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(value) && !/\s/.test(value);
export function isShopOfferSettings(value: unknown): value is ShopOfferSettings {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const item = value as Record<string, unknown>;
  return Object.keys(item).length === 5 && shopOfferId(item.packageDocId) &&
    (item.priceWebshop === null || validWebshopPrice(item.priceWebshop)) && (item.vatRate === null || validWebshopVat(item.vatRate)) &&
    typeof item.shopEnabled === "boolean" && Number.isSafeInteger(item.revision) &&
    (item.revision as number) >= 0 && (item.revision as number) <= Number.MAX_SAFE_INTEGER - 1;
}
export function shopOfferResultMatches(value: ShopOfferSettings, id: string, body: ShopOfferBody): boolean {
  return value.packageDocId === id && value.revision === body.expectedRevision + 1 && value.priceWebshop === body.priceWebshop &&
    value.vatRate === body.vatRate && value.shopEnabled === body.shopEnabled;
}
